var map = {
	"./build.svg": 14999,
	"./chart.svg": 68155,
	"./five.svg": 85941,
	"./four.svg": 79297,
	"./list.svg": 77293,
	"./monitor.svg": 81877,
	"./one.svg": 22831,
	"./server.svg": 45804,
	"./seven.svg": 44920,
	"./six.svg": 4895,
	"./system.svg": 69202,
	"./tab.svg": 410,
	"./three.svg": 61455,
	"./tool.svg": 75547,
	"./two.svg": 16877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;